import React, {useState} from "react";

const GraTillGuldQuestions = ({ qna, answers}) => {

    const [ questions, setQuestions ] = useState( qna );

    const handleAnswer = ( answer, index ) => {

        let questionsCopy = questions;
    
        questionsCopy[index].a = answer;

        setQuestions( [...questionsCopy] );

        answers( questionsCopy );

    }

    return (
        <div className="gtg-wrap mb-6">
            <div className="gtg-questions" style={{maxWidth: '800px'}}>

                { questions.map( (question, index) => {
                    return (
                        <div className="gtg-question" key={index}>
                            <div className="d-flex border-bottom">
                                <div className="flex-grow-1 d-flex align-items-center ps-3">
                                    <span className="gtg-qu">{question.q}</span>
                                </div>
                                <div className="gtg-answers d-flex">
                                    <div className="gtg-answer-wrap p-2">
                                        <div className={`gtg-answer rounded-circle bg-sy-gray text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium ${question.a === 1 ? 'active': ''}`} onClick={ () => handleAnswer( 1, index )}>Grå</div>
                                    </div>
                                    <div className="gtg-answer-wrap p-2">
                                        <div className={`gtg-answer rounded-circle bg-sy-bronze text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium ${question.a === 2 ? 'active': ''}`} onClick={ () => handleAnswer( 2, index )}>Brons</div>
                                    </div>
                                    <div className="gtg-answer-wrap p-2">
                                        <div className={`gtg-answer rounded-circle bg-sy-silver text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium ${question.a === 3 ? 'active': ''}`} onClick={ () => handleAnswer( 3, index )}>Silver</div>
                                    </div>
                                    <div className="gtg-answer-wrap p-2">
                                        <div className={`gtg-answer rounded-circle bg-sy-gold text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium ${question.a === 4 ? 'active': ''}`} onClick={ () => handleAnswer( 4, index )}>Guld</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default GraTillGuldQuestions;